module.exports = function isFunction(x) {
  return typeof x === 'function';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/isFunction.js
 ** module id = 65
 ** module chunks = 0
 **/